var dayOverride = 'fx_2d2fb1e5_18910t50';
var dayText = 'fx_2d2fb1e5_18910t51';

export { dayOverride, dayText };
//# sourceMappingURL=dayOverride.vanilla.mjs.map
